module.exports = __webpack_public_path__ + "img/logo.2e658199.svg";